module.exports = __webpack_public_path__ + "e3f88dc3cc6d6bcd9d4d8a52b0cecd2f.MP3";